import { Box, Stack } from "@mui/material";
import PaginationControl from "@entrilia/shared/components/PaginationControl";
import RowsPerPageSelector from "./RowsPerPageSelector";

interface Props {
  totalPages: number | undefined;
  rowsPerPage: number;
  pageIndex: number;
  align?: "left" | "right";
  onRowsPerPageChange: (value: number) => void;
  onPageIndexChange: (value: number) => void;
}

const GridPaginationFooter = ({
  totalPages,
  rowsPerPage,
  pageIndex,
  align = "right",
  onRowsPerPageChange,
  onPageIndexChange,
}: Props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: align === "left" ? "flex-start" : "flex-end",
        mt: 1,
      }}
    >
      <Stack direction="row" spacing={2.5} sx={{ alignItems: "center" }}>
        <Box sx={{ pt: 1 }}>
          <RowsPerPageSelector value={rowsPerPage} onChange={onRowsPerPageChange} />
        </Box>
        <PaginationControl totalPages={totalPages} pageIndex={pageIndex} onPageIndexChange={onPageIndexChange} />
      </Stack>
    </Box>
  );
};

export default GridPaginationFooter;
